var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7546 3H6C5.44772 3 5 3.44772 5 4V16H2V19C2 20.66 3.34 22 5 22H17C18.66 22 20 20.66 20 19V15.4185C19.3693 15.6738 18.6986 15.851 18 15.9381V19C18 19.55 17.55 20 17 20C16.45 20 16 19.55 16 19V16H7V5H9.58152C9.87526 4.27434 10.2724 3.60158 10.7546 3ZM4 19C4 19.55 4.45 20 5 20H14V18H4V19Z",
    fill: "#6A7F9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0388 7.96981C14.032 8.87133 15.6287 10.468 16.5302 12.4612L17 13.5L17.4698 12.4612C18.3713 10.468 19.968 8.87133 21.9612 7.96981L23 7.5L21.9612 7.03019C19.968 6.12867 18.3713 4.53201 17.4698 2.53875L17 1.5L16.5302 2.53875C15.6287 4.53201 14.032 6.12867 12.0388 7.03019L11 7.5L12.0388 7.96981Z",
    fill: "#4555D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateSummary);
export default __webpack_public_path__ + "static/media/generate-summary.ba561b677433bb245bb7a8d94618f19a.svg";
export { ForwardRef as ReactComponent };